import { useState } from 'react';
import './checkbox.scss';

export type CheckboxProps = {
  label: string;
  initialValue: boolean;
  onValueChange: (value: boolean) => void;
  dataTestId?: string;
};

export const Checkbox = ({
  label,
  initialValue,
  onValueChange,
  dataTestId,
}: {
  label: string;
  initialValue: boolean;
  onValueChange: (value: boolean) => void;
  dataTestId?: string;
}) => {
  const [value, setValue] = useState(initialValue);

  return (
    <div className="checkbox-container">
      <label htmlFor={label + '_checkbox'}>
        <div>{label}</div>
      </label>
      <input
        data-testid={dataTestId}
        type="checkbox"
        className="custom-checkbox"
        id={label + '_checkbox'}
        checked={value}
        onChange={(e) => {
          setValue(e.target.checked);
          onValueChange(e.target.checked);
          e.preventDefault();
        }}
      />
    </div>
  );
};
